"use strict";

import { ApplicationConstants } from 'Constants/ApplicationConstants';
import { FormConstants } from 'Constants/Forms/FormConstants';
import { AppDispatcher } from 'Dispatcher';
/**
 *
 * @param {string} route Backbone.Router's route
 */

export function navigate(route) {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.NAVIGATE,
    route: route
  });
}
export function routerLoaded() {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.ROUTER_LOADED
  });
}
export function langLoaded() {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.LANG_LOADED
  });
}
export function loadForm(formObj) {
  AppDispatcher.asyncDispatch({
    actionType: FormConstants.FORM_INITIALIZE,
    formObj: formObj
  });
}
export function logout() {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.DO_LOGOUT
  });
}
export function changeTheme(theme) {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.CHANGE_THEME,
    theme: theme
  });
}
export function sideDrawerUpdateWidth(width) {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.SIDE_DRAWER_UPDATE_WIDTH,
    width: width
  });
}
export function sideDrawerOpen() {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.SIDE_DRAWER_OPEN
  });
}
export function sideDrawerClose() {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.SIDE_DRAWER_CLOSE
  });
}
export function sideDrawerChangeAnchor(anchor) {
  AppDispatcher.dispatch({
    actionType: ApplicationConstants.SIDE_DRAWER_CHANGE_ANCHOR,
    anchor: anchor
  });
}
/**
 * @param {string} value
 */

export function changeDocumentTitle(value) {
  AppDispatcher.asyncDispatch({
    actionType: ApplicationConstants.CHANGE_DOCUMENT_TITLE,
    value: value
  });
}
export function setDocumentTitle() {
  AppDispatcher.asyncDispatch({
    actionType: ApplicationConstants.SET_DOCUMENT_TITLE
  });
}